import { FilePdfOutlined, LeftCircleOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Drawer, Modal, Select, Input } from "antd";

import {
  faBiking,
  faDownload,
  faExchangeAlt,
  faHandHoldingUsd,
  faSortAmountDownAlt,
} from "@fortawesome/free-solid-svg-icons";

import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import { OrderTypeArray } from "../../../utils";
import { authenticateToken } from "../../../utils/auth";
import { responseNotification } from "../../../utils/notify";
import { debounce } from "lodash";
import axios from "axios";
import EditOrder from "../EditOrder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useHistory } from "react-router-dom";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import OrderInvoice from "../OrderDetails/OrderInvoice";
import OrderPaymentLogs from "../OrderDetails/paymentLogs";
import { isAllowedService } from "../../../utils/services";
const { Option } = Select;

const OrderLayoutHeader = ({
  orderDetails,
  selectedProducts,
  refetch,
}): ReactElement => {
  const [merchantId, setMerchantId] = useState<any>();
  const [shopId, setShopId] = useState<any>();
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [merchantOptions, setMerchantOptions] = useState({
    loading: false,
    list: [],
  });

  const [singleOrderInfo, setSingleOrderInfo] = useState<any>();
  const [statusModal, setStatusModal] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(undefined);
  const [orderTransferModal, setOrderTransferModal] = useState(undefined);
  const [status, setStatus] = useState("");
  const [type, setType] = useState(orderDetails?.type);
  const [key, setKey] = useState("");
  const [note, setNote] = useState("");
  const [assignment, setAssignment] = useState(false);
  const [showInoice, setShowInvoice] = useState(false);
  const [pdfloading, setPdfloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedDeliveryManId, setSelectedDeliveryManId] = useState("");
  const [deliveryManData, setDeliveryManData] = useState({
    loading: false,
    list: [],
  });
  const [form] = Form.useForm();
  const route = useHistory();
  const fetchRef = useRef(0);

  const [showForm, setShowForm] = useState(undefined);

  const onStatusChange = async (data) => {
    if (status === "CANCELLED" && !note) {
      responseNotification("To cancel note is required!");
    } else {
      setLoading(true);

      const readyData = data && {
        orderId: singleOrderInfo?.orderId,
        status: status,
        note: note,
      };

      await fetch(`${process.env.REACT_APP_ORDER_API}/admin/order`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            form.resetFields();
            refetch();
            setStatusModal(false);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const fetchDeliveryMan = useCallback(async (value) => {
    setDeliveryManData({ loading: true, list: [] });
    await fetch(
      `${
        process.env.REACT_APP_RIDER_API
      }/admin/driver?status=VERIFIED&mobileNumberOrName=${value?.replace(
        "+88",
        ""
      )}`,
      {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setDeliveryManData({
          loading: true,
          list: res?.drivers?.map((driver) => ({
            label: `${driver?.mobileNumber} ${driver?.name}`,
            value: driver?.id,
          })),
        });
      });
  }, []);

  // =======================================
  const getMerchantsOptions = useCallback(
    async (key?: string) => {
      setMerchantOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      const res = await axios.get(
        `${encodedUri}/merchant/all?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (key ? `&name=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setMerchantOptions({
        loading: false,
        list: res.data?.merchants?.map((merchant) => ({
          label: merchant.name,
          value: merchant.id,
        })),
      });
    },
    [type]
  );

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/by-merchant?page=0&limit=20` +
          (merchantId ? `&merchantId=${merchantId}` : ``) +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            value: shop?.id,
            label: shop?.name,
          };
        }),
      });
    },
    [type, merchantId]
  );

  //
  const onOrderTransfer = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      orderId: orderDetails?.orderId,
      shopId: shopId,
    };

    await fetch(
      `${process.env.REACT_APP_ORDER_API}/order/order-transfer-between-shop`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Order Transfered Successfully", "success");
          getShopsOptions();
          setOrderTransferModal(!orderTransferModal);
          form.resetFields();
          refetch();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };
  //

  const onBkashManual = async (data) => {
    setLoading(true);

    const readyData = data && {
      orderId: singleOrderInfo?.baseOrderId,
      amount: data.amount,
      transactionId: data.transactionId,
    };

    await fetch(
      `${process.env.REACT_APP_PAY_API}/bkash/manual/success/from-app`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        if (res.statusCode === 200) {
          responseNotification("Payment Received Successfully", "success");
          getShopsOptions();
          setShowForm(undefined);
          form.resetFields();
          refetch();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };
  // =======================================

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "merchant") getMerchantsOptions(value);
        else if (field === "shop") getShopsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getMerchantsOptions, getShopsOptions]);

  const debounceDeliveryManFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      if (fetchId !== fetchRef.current) {
        return;
      }
      fetchDeliveryMan(value);
    };
    return debounce(loadOptions, 800);
  }, [fetchDeliveryMan]);

  const assignDeliveryHero = () => {
    if (selectedDeliveryManId) {
      setLoading(true);
      axios
        .put(
          `${process.env.REACT_APP_ORDER_API}/admin/order`,
          {
            deliveryManId: selectedDeliveryManId,
            orderId: orderDetails?.orderId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            responseNotification("Assigned Successfully!");
            refetch();
            setAssignment(false);
          } else {
            responseNotification("Assigmenation Failed!", "error");
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(
            err?.message || "Assigmenation Failed!",
            "error"
          );
          console.error(err);
        });
    } else {
      responseNotification("Select a delivery man", "warning");
    }
  };

  useEffect(() => {
    setPdfloading(true);
    setSingleOrderInfo(orderDetails);
    setTimeout(() => setPdfloading(false), 3000);
    setStatus(orderDetails?.status);
    setType(orderDetails?.type);
  }, [orderDetails]);

  useEffect(() => {
    if (orderTransferModal) {
      getMerchantsOptions();
    }
  }, [getMerchantsOptions, orderTransferModal]);

  useEffect(() => {
    if (merchantId) {
      getShopsOptions();
    }
  }, [getShopsOptions, merchantId]);

  useEffect(() => {
    if (type) {
      getMerchantsOptions();
    }
  }, [getMerchantsOptions, type]);

  return (
    <React.Fragment>
      <Row className="row">
        <Col span={7}>
          <div className="page-heading-content">
            <Link
              to={""}
              className="mr-2 text-dark"
              onClick={(e) => {
                e.preventDefault();
                route?.goBack();
              }}
            >
              <LeftCircleOutlined />
            </Link>
            <h3 className="d-flex-l d-flex-nowrap d-flex-base mb-0">
              Order Details
            </h3>
          </div>
        </Col>

        <Col span={17} className="text-right">
          {isAllowedService(`Orders Payment Status`) && (
            <Button
              type="dashed"
              className="mx-1"
              onClick={() => setPaymentStatus(true)}
              title="Payment Status"
            >
              <FontAwesomeIcon icon={faHandHoldingUsd} />
            </Button>
          )}

          {isAllowedService(`Orders Assign DM`) && (
            <Button
              type="dashed"
              className="mx-1"
              onClick={() => setAssignment(true)}
              disabled={
                // !!orderDetails?.deliveryManId ||
                orderDetails?.status === "ON_DELIVERY" ||
                orderDetails?.status === "PICKED" ||
                orderDetails?.status === "DELIVERED" ||
                orderDetails?.status === "COMPLETED" ||
                orderDetails?.status === "REVIEWED" ||
                orderDetails?.status === "CANCELLED"
              }
              title="Assign Delivery Hero"
            >
              <FontAwesomeIcon
                icon={faBiking}
                className={` text-${
                  orderDetails?.deliveryManId ? "success" : "dark"
                }`}
              />
            </Button>
          )}

          {isAllowedService(`Orders Change Status`) && (
            <Button
              type="dashed"
              className="mx-1"
              onClick={() => setStatusModal(true)}
              disabled={
                orderDetails?.status === "PICKED" ||
                orderDetails?.status === "COMPLETED" ||
                orderDetails?.status === "DELIVERED" ||
                orderDetails?.status === "REVIEWED" ||
                orderDetails?.status === "CANCELLED"
              }
              title="Change Status"
            >
              <FontAwesomeIcon icon={faSortAmountDownAlt} />
            </Button>
          )}

          {isAllowedService(`Orders Order Transfer`) && (
            <Button
              type="dashed"
              title="Transfer Order"
              className="mx-1"
              onClick={() => setOrderTransferModal(true)}
              disabled={
                orderDetails?.status === "PICKED" ||
                orderDetails?.status === "COMPLETED" ||
                orderDetails?.status === "DELIVERED" ||
                orderDetails?.status === "REVIEWED" ||
                orderDetails?.status === "CANCELLED"
              }
            >
              <FontAwesomeIcon icon={faExchangeAlt} />
            </Button>
          )}

          {isAllowedService(`Orders Order Details`) && (
            <Button
              type="dashed"
              title="Order Invoice"
              className="ml-1"
              onClick={() => setShowInvoice(!showInoice)}
            >
              <FilePdfOutlined />
            </Button>
          )}
        </Col>
      </Row>

      <Drawer
        destroyOnClose={true}
        title="Add Category"
        width={900}
        onClose={() => {}}
        visible={false}
        bodyStyle={{ paddingBottom: 0 }}
        footer={
          <div
            style={{
              textAlign: "left",
            }}
          ></div>
        }
      >
        <EditOrder />
      </Drawer>

      <Modal
        title={"Payment History"}
        okButtonProps={{
          disabled:
            !!!paymentStatus ||
            singleOrderInfo?.total <= singleOrderInfo?.totalPaid,
        }}
        visible={!!paymentStatus}
        okText="bKash Manual"
        onOk={() => {
          setShowForm(true);
        }}
        cancelButtonProps={{
          color: "red",
          type: "ghost",
          danger: true,
        }}
        confirmLoading={loading}
        onCancel={() => {
          setPaymentStatus(false);
          refetch();
        }}
        destroyOnClose={true}
        width={"70%"}
      >
        {showForm && (
          <Form
            layout="inline"
            onFinish={onBkashManual}
            className="mb-4"
            size="large"
          >
            <Form.Item
              hasFeedback
              name="amount"
              rules={[
                { required: true },
                {
                  validator: async (_, value) => {
                    if (
                      value >
                      singleOrderInfo?.total - singleOrderInfo?.totalPaid
                    ) {
                      return Promise.reject(
                        new Error("Amount Must be Equal or less than Balance")
                      );
                    }
                  },
                },
              ]}
              initialValue={
                singleOrderInfo?.baseAmount - singleOrderInfo?.totalPaid
              }
            >
              <Input id="amount" placeholder="Enter Amount" />
            </Form.Item>

            <Form.Item
              hasFeedback
              name="transactionId"
              rules={[
                {
                  required: true,
                  message: "Transaction ID is required",
                },
              ]}
            >
              <Input id="transactionId" placeholder="Enter Transaction ID" />
            </Form.Item>

            <Button danger type="primary" htmlType="submit">
              Recieve
            </Button>
          </Form>
        )}

        <OrderPaymentLogs orderDetails={orderDetails} />
      </Modal>

      <Modal
        title={"Transfer Order"}
        visible={!!orderTransferModal}
        okText="Transfer"
        onOk={onOrderTransfer}
        cancelButtonProps={{
          color: "red",
          type: "ghost",
          danger: true,
        }}
        confirmLoading={loading}
        onCancel={() => {
          setOrderTransferModal(!orderTransferModal);
        }}
        destroyOnClose={true}
      >
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          form={form} // like ref
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item label="Select Merchant">
            <Select
              allowClear
              showSearch
              placeholder="Select Merchant"
              optionFilterProp="children"
              onChange={(val) => setMerchantId(val)}
              onSearch={(e) => handleSearch(e, "category")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {merchantOptions.list.map((merchant) => (
                <Option value={merchant.value} key={merchant.value}>
                  {merchant.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Select Shop" name="shopId">
            <Select
              allowClear
              autoClearSearchValue
              onSearch={() => {
                getShopsOptions();
              }}
              onChange={(val) => setShopId(val)}
              options={shopsOptions?.list}
              maxTagTextLength={20}
              disabled={!merchantId}
              placeholder="Select Shop to Transfer Order"
            ></Select>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={"Change Order Status"}
        okButtonProps={{ disabled: !!!status }}
        visible={!!statusModal}
        onOk={onStatusChange}
        okText="Change"
        cancelButtonProps={{
          color: "red",
          type: "ghost",
          danger: true,
        }}
        confirmLoading={loading}
        onCancel={() => {
          setStatusModal(false);
        }}
        destroyOnClose={true}
      >
        <div>
          <Form layout="vertical" onFinish={onStatusChange}>
            <Form.Item
              hasFeedback
              label="Status"
              name="status"
              initialValue={status}
              rules={[
                {
                  required: true,
                  message: "Status is required",
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                onChange={(val) => setStatus(val as string)}
                onSearch={debounceDeliveryManFetcher}
                filterOption={(input, option) =>
                  option.children
                    ?.toString()
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {Object.values(OrderTypeArray)?.map((type, i) => (
                  <Option value={type} key={i}>
                    {type?.split("_").join(" ")}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item hasFeedback label="Note" name="note">
              <Input.TextArea
                onChange={(val) => setNote(val?.target.value)}
                rows={5}
                id="note"
                placeholder="Write some note"
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>

      <Modal
        title={
          <div className="d-flex-l">
            <FontAwesomeIcon
              icon={faBiking}
              className="mr-2"
              style={{ color: "#e73d42" }}
            />{" "}
            Assign a Delivery Man
          </div>
        }
        okButtonProps={{ disabled: !!!selectedDeliveryManId }}
        visible={!!assignment}
        onOk={assignDeliveryHero}
        okText="Assign"
        cancelButtonProps={{
          color: "red",
          type: "ghost",
          danger: true,
        }}
        confirmLoading={loading}
        onCancel={() => {
          setDeliveryManData({ loading: false, list: [] });
          setSelectedDeliveryManId("");
          setAssignment(false);
        }}
        destroyOnClose={true}
      >
        <div>
          <Select
            showSearch
            style={{ width: "100%", marginBottom: 15 }}
            placeholder="Select a Delivery Man 01..."
            optionFilterProp="children"
            onChange={(val) => setSelectedDeliveryManId(val as string)}
            onSearch={debounceDeliveryManFetcher}
            filterOption={(input, option) =>
              option.children
                ?.toString()
                .toLowerCase()
                .indexOf(input.toLowerCase()?.replace("+88", "")) >= 0
            }
          >
            {deliveryManData?.list?.map((man, i) => (
              <Option value={man?.value} key={i}>
                {man?.label?.replace("+88", "")}
              </Option>
            ))}
          </Select>
        </div>
      </Modal>

      <Modal
        centered
        title={
          <div className="d-flex-l">
            <FontAwesomeIcon
              icon={faDownload}
              className="mr-2"
              style={{ color: "#e73d42" }}
            />{" "}
            Download Invoice
          </div>
        }
        width={800}
        visible={!!showInoice}
        // onOk={() => print(['1'])}
        okText={
          <PDFDownloadLink
            document={
              <OrderInvoice
                orderDetails={singleOrderInfo}
                selectedProducts={selectedProducts}
              />
            }
            fileName="order.pdf"
          >
            {({ blob, url, loading, error }) =>
              loading ? "Loading document..." : "Download PDF"
            }
          </PDFDownloadLink>
        }
        cancelButtonProps={{
          type: "primary",
          danger: true,
        }}
        // confirmLoading={loading}
        onCancel={() => {
          setShowInvoice(false);
        }}
        destroyOnClose={true}
      >
        <div>
          <PDFViewer
            showToolbar={false}
            style={{ width: "100%", minHeight: 600, border: 0 }}
          >
            <OrderInvoice
              orderDetails={singleOrderInfo}
              selectedProducts={selectedProducts}
            />
          </PDFViewer>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default React.memo(OrderLayoutHeader);
